export interface Segment {
  index: number;
  speakerLabel: string;
  start: number;
  end: number;
  text: string;
  words: {
    word: string;
    duration: number;
    offset: number;
    confidence: number;
  }[];
}

export interface Transcription {
  speakers: Record<string, string>;
  segments: Segment[];
  recordingTitle?: string;
  recordingDate?: string;
}

// Sent when creating a recording (POST /v0/recording body) and returned on every recording-list
// item (GET /v0/recording, distinct from the recording-details response shape) as `recordingType`.
export enum RecordingCreationType {
  LIVE_RECORDING = "LiveRecording",
  UPLOADED_RECORDING = "UploadedRecording",
}

export interface Recording {
  id: number;
  recordingId: string;
  agendaId: string;
  title: string;
  date: string;
  lastModified?: string;
  duration: string;
  status: number;
  users: User[];
  actions: Action[];
  recordingUrl: string;
  adminEmail: string;
  transcript: Transcription;
  meetingMinutes: string;
  summary: string;
  customerName: string;
  transcriptHtml: string;
  exports: Export[];
  subjects: string[];
  audioHash?: string | null;
  audioHashFromFrontend?: string | null;
  isOnIndexDB?: boolean;
  isOldData?: boolean;
  isHashEqual?: boolean | null;
  isSync?: boolean;
  isUploadInterrupted: boolean;
  isFailedDifferentHash?: boolean;
  recordingType?: RecordingCreationType;
}

export interface User {
  id: number;
  userId: string;
  firstName: string;
  lastName: string;
  email: string;
  recordingId: string;
  recording: string;
}

export interface Action {
  id: number;
  actionId: string;
  actions: Record<string, unknown>;
  recording: string;
  recordingId: string;
}

export interface Export {
  id: string;
  recordingExportId: string;
  fileName: string;
  recording: string;
  recordingId: string;
  exportType: number;
  status: number;
  exportedDate: string;
  exportSize: number;
}

export interface RecordingExportItem {
  id: string;
  exportType: number;
  exportedDate: string;
  size: number;
  status: number;
}

export interface Subject {
  number?: string;
  id: string;
  time: string;
  subject: string;
  startOffSet?: string;
  endOffSet?: string;
  offSet: string;
  segments: {
    startOffSet: string;
    endOffSet: string;
  }[];
  recordingAgendaId: string;
  recordingSubjectId: string;
  recordingAgendaItemId: string;
  recording: Recording;
  recordingId: string;
}

export interface RecordingUUIDUser {
  firstName: string;
  lastName: string;
  email?: string;
}
